import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IFileViewModel extends IModelBase {
  Uid: string
  FileName: string
  ContentType: string
  UserId: string
  FileBytes: number[]
  ErrorMessage: string
}

@Injectable()
export class FileViewModelODataService extends ODataService<IFileViewModel> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'FileViewModels'
  }
}
